import { StatusColumnFormat } from './ColumnsFormatters/StatusColumn';
import { ResendColumn } from './ColumnsFormatters/ResendColumn';
import { DetailColumn } from './ColumnsFormatters/DetailColumn';
import { formatDate } from 'src/utils/dates';
import { templateNotification } from './mail-template';

export const defaultForm = {
	idOrgano: '',
	idSesion: '',
	resolucion: '',
	unidadesAdministrativas: [],
	usuarios: [],
	asunto: '',
	contenido: templateNotification(),
};

export const action_buttons = (
	sendNotification,
	onCancel,
	onClear,
	disableFields,
	loaderSend
) => [
	{
		title: disableFields ? 'Regresar' : 'Cancelar',
		color: 'light-dark',
		onClick: onCancel,
		className: 'ml-lg-2',
	},
	{
		title: 'Limpiar',
		color: 'info',
		onClick: onClear,
		className: disableFields ? 'd-none' : 'ml-lg-2',
	},
	{
		title: 'Enviar Notificación',
		color: 'primary',
		onClick: sendNotification,
		className: disableFields ? 'd-none' : 'ml-lg-2',
		loading: loaderSend,
		disabled: loaderSend,
	},
];

export const form = (
	organs = [],
	sessionsPrevious = [],
	institutions = [],
	users = [],
	disableFields
) => [
	{
		label: 'Órgano Colegiado',
		name: 'idOrgano',
		placeholder: 'Órgano Colegiado',
		type: 'dropdown',
		options: [...organs],
		column: 4,
		disabled: disableFields,
	},
	{
		label: 'Sesión',
		name: 'idSesion',
		type: 'dropdown',
		options: [...sessionsPrevious],
		column: 4,
		disabled: disableFields,
	},
	{
		label: 'Resolución',
		name: 'resolucion',
		type: 'text',
		column: 4,
		disabled: disableFields,
	},
	{
		label: 'Filtrar usuarios por unidad administrativa',
		name: 'unidadesAdministrativas',
		type: 'search-multiple',
		options: [...institutions],
		column: 12,
		disabled: disableFields,
	},
	{
		label: '*Usuarios',
		name: 'usuarios',
		type: 'search-multiple',
		options: [...users],
		column: 12,
		disabled: disableFields,
	},
	{
		label: '*Asunto',
		name: 'asunto',
		type: 'text',
		column: 12,
		disabled: disableFields,
		adjustable: true,
	},
];

export const inputFile = (dataFile) => [
	dataFile.idEntidad !== 0
		? {
				type: 'icon-upload_minos',
				data: dataFile,
				id: 'BtnUploadFileNotification',
				column: 12,
				disabled: true,
		  }
		: {},
];

export const columns = (onResend, onEye) => [
	{
		dataField: 'id',
		text: 'Reenviar',
		classes: 'text-center',
		formatter: ResendColumn,
		formatExtraData: {
			onResend,
		},
	},
	{
		dataField: 'fechaEnvio',
		text: 'Fecha y hora de envio',
		headerAlign: 'left',
		formatter: (value) => {
			return formatDate('EEEE PP, HH:mm', new Date(value));
		},
	},
	{
		dataField: 'asunto',
		text: 'Asunto',
		headerAlign: 'left',
	},
	{
		dataField: 'nombreUsuarios',
		text: 'Usuarios',
		headerAlign: 'left',
	},
	{
		dataField: 'nombreUnidadesAdministrativas',
		text: 'Unidad Administrativa',
		style: { maxWidth: '350px' },
		headerAlign: 'left',
	},
	{
		dataField: 'estatus',
		text: 'Estatus',
		classes: 'text-center',
		formatter: StatusColumnFormat,
	},
	{
		dataField: 'id',
		text: 'Ver detalle',
		classes: 'text-center',
		formatter: DetailColumn,
		formatExtraData: {
			onEye,
		},
	},
];

export const defaultSelects = {
	value: '',
	text: '',
};

export const defaultFilter = {
	unit: '',
	user: defaultSelects,
	key: defaultSelects,
};

export const filterForm = (
	onConfirmFilter,
	onClear,
	institutions = [],
	users,
	//disableFilter = false,
	usersKey
) => [
	{
		label: 'Unidad Administrativa',
		name: 'unit',
		type: 'dropdown',
		options: [...institutions],
		column: 4,
		//disabled: disableFilter,
	},
	{
		placeholder: 'Nombre de usuario',
		label: 'Usuario',
		name: 'user',
		type: 'search',
		options: [...users],
		column: 4,
	},
	{
		label: 'Clave de usuario',
		placeholder: 'Buscar por IN/IS',
		name: 'key',
		type: 'search',
		options: [...usersKey],
		column: 2,
	},
	{
		label: 'Limpiar',
		name: 'Limpiar',
		color: 'light-primary',
		type: 'button',
		onClick: onClear,
		column: 1,
	},
	{
		label: 'Buscar',
		name: 'Buscar',
		color: 'info',
		type: 'button',
		column: 1,
		onClick: onConfirmFilter,
	},
];
